import styled from "@emotion/styled";

const GridStyle = styled.div((props: { columns?: string, rows?: string, gap?: string, justify?: 'center' | 'start' | 'end' | 'stretch', align?: 'normal' | 'stretch' | 'center' | 'start' | 'end' }) => ({
  display: 'grid',
  gridTemplateColumns: props.columns || 'auto',
  gridTemplateRows: props.rows || 'auto',
  gap: props.gap || '0',
  justifyItems: props.justify || 'normal',
  alignItems: props.align || 'normal'
}));

interface Props {
  children: React.ReactNode;
  columns?: string;
  rows?: string;
  justify?: 'center' | 'start' | 'end' | 'stretch';
  align?: 'normal' | 'stretch' | 'center' | 'start' | 'end';
  gap?: string;
  rowGap?: string | number;
  columnGap?: string | number;
  style?: React.CSSProperties;
  className?: string;
}

export const Grid = ({ columns, rows, gap, rowGap = 0, columnGap = 0, justify, align, children, style, className }: Props) => {
  const gapValue = gap || `${rowGap}px ${columnGap}px`;

  return <GridStyle columns={columns} rows={rows} justify={justify} align={align} gap={gapValue} className={className} style={style}>{children}</GridStyle>;
}
